import React from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { Chip } from "@mui/material";

const PaymentTable = ({ paymentReport, setPagination }) => {

  const getStatusChip = (status) => {
    switch (status) {
      case "captured":
        return <Chip label="Captured" color="success" />;
      case "refunded":
        return <Chip label="Refunded" color="primary" />;
      case "refund_pending":
        return <Chip label="Refund Pending" color="warning" />;
      case "refund_failed":
        return <Chip label="Refund Failed" color="error" />;
      default:
        return <Chip label={status} />;
    }
  };

  const columns = [
    { field: "displayIndex", headerName: "No", width: 90 },
    { field: "id", headerName: "Payment Id", width: 100 },
    { field: "business_name", headerName: "Business Name", width: 170 },
    { field: "service_name", headerName: "Service Name", width: 180 },
    { field: "user_name", headerName: "User Name", width: 170 },
    { field: "user_phone", headerName: "User Phone", width: 150 },
    { field: "amount", headerName: "Amount", width: 100 },
    { field: "payment_method", headerName: "Payment Method", width: 150 },
    { field: "created_at", headerName: "Payment Date and Time", width: 200 },
    {
      field: "status",
      headerName: "Status",
      width: 150,
      renderCell: (params) => getStatusChip(params.value),
    },
  ];

  return (
    <Box
      sx={{
        flexGrow: 1,
        maxWidth: { xs: 650, sm: 682, lg: 1350 },
        bgcolor: "background.paper",
      }}
    >
      <DataGrid
        rows={paymentReport}
        columns={columns}
        disableSelectionOnClick
        pageSizeOptions={[25, 50, 100]}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 25,
            },
          },
        }}
        onPaginationModelChange={setPagination}
      />
    </Box>
  );
};

export default PaymentTable;
